import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-94c7f88a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sa-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "sa-page-title" }, "Super-Administration", -1))
const _hoisted_3 = { class: "sa-subnav" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "sa-title" }, "Dokumente"),
  /*#__PURE__*/_createElementVNode("p", { class: "sa-subtitle" }, " Einzelne Dokumente pflegen und für Einrichtungen veröffentlichen. Einrichtungen stellen daraus ihre eigenen Unterweisungen zusammen. ")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "sa-loading"
}
const _hoisted_6 = {
  key: 1,
  class: "sa-error"
}
const _hoisted_7 = { class: "sa-card" }
const _hoisted_8 = { class: "sa-table" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Dokument"),
    /*#__PURE__*/_createElementVNode("th", null, "Typ"),
    /*#__PURE__*/_createElementVNode("th", null, "Version"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Aktionen")
  ])
], -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  colspan: "5",
  class: "sa-empty"
}
const _hoisted_12 = { class: "sa-course-title" }
const _hoisted_13 = { class: "sa-actions" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
], -1))
const _hoisted_16 = ["disabled", "onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  })
], -1))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "2",
    y1: "12",
    x2: "22",
    y2: "12"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" })
], -1))
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
], -1))
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "sa-modal sa-modal-wide" }
const _hoisted_24 = { class: "il-field" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "il-label",
  for: "il-md-title"
}, [
  /*#__PURE__*/_createTextVNode("Titel "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_26 = { class: "il-field" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "il-label" }, [
  /*#__PURE__*/_createTextVNode("Inhalt "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_28 = {
  key: 0,
  class: "il-editor-loading"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-secondary",
  role: "status"
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Inhalt wird geladen …", -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "il-hint",
  style: {"margin-top":"8px"}
}, " Über „Platzhalter …\" fügen Sie Felder ein, die beim Anzeigen automatisch gefüllt werden: der Name der Einrichtung und das aktuelle Datum. Ein Feld zum Ausfüllen erscheint im Dokument als Linie. ", -1))
const _hoisted_33 = { class: "il-check" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Für Einrichtungen veröffentlichen", -1))
const _hoisted_35 = {
  key: 0,
  class: "il-error"
}
const _hoisted_36 = { class: "sa-modal-actions" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "sa-modal" }
const _hoisted_41 = { class: "il-field" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "il-label",
  for: "il-file-title"
}, [
  /*#__PURE__*/_createTextVNode("Titel "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_43 = { class: "il-field" }
const _hoisted_44 = { class: "il-label" }
const _hoisted_45 = {
  key: 0,
  class: "req"
}
const _hoisted_46 = ["disabled"]
const _hoisted_47 = {
  key: 0,
  class: "il-hint",
  style: {"margin-top":"6px"}
}
const _hoisted_48 = { class: "il-check" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Für Einrichtungen veröffentlichen", -1))
const _hoisted_50 = {
  key: 0,
  class: "il-error"
}
const _hoisted_51 = { class: "sa-modal-actions" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { class: "sa-modal" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Dokument löschen", -1))
const _hoisted_56 = {
  key: 0,
  class: "il-error"
}
const _hoisted_57 = { class: "sa-modal-actions" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = ["disabled"]

import { ref, computed, onMounted } from 'vue';
import { useStore } from '@/store';
import DotMenu from '@/components/DotMenu.vue';
import RichTextEditor from '@/components/RichTextEditor.vue';
import type { InstructionContent } from '@/store/instructionLibrary';
import { titleFromFileName } from '@/utils/fileTitle';
import { renderMarkdownRaw, htmlToMarkdown, openMarkdownPreview } from '@/utils/instructionMarkdown';


export default /*#__PURE__*/_defineComponent({
  __name: 'InstructionLibraryView',
  setup(__props) {

const ACCEPT = 'application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document';

const store = useStore();

const loading = ref(true);
const error = ref('');
const query = ref('');

const items = computed<InstructionContent[]>(() => store.getters['instructionLibrary/getItems']);
const filteredItems = computed<InstructionContent[]>(() => {
  const q = query.value.trim().toLowerCase();
  return items.value
    .filter((c) => !q || c.title.toLowerCase().indexOf(q) >= 0)
    .slice()
    .sort((a, b) => a.title.localeCompare(b.title, 'de'));
});

onMounted(async () => {
  try {
    await store.dispatch('instructionLibrary/LOAD', { force: true });
  } catch (e) {
    error.value = 'Die Dokumente konnten nicht geladen werden.';
  } finally {
    loading.value = false;
  }
});

function typeLabel(c: InstructionContent): string {
  const t = String(c.fileType);
  if (t === 'md') return 'Editor';
  if (t === 'pdf') return 'PDF';
  return 'Word';
}

// ── Editor-Dokumente (Markdown) ───────────────────────────
// Der Editor arbeitet mit HTML; gespeichert wird weiterhin Markdown.
// origMarkdown hält den geladenen Stand, um unnötige neue Versionen zu vermeiden.
const mdModal = ref<{
  visible: boolean; contentId: string | null; title: string; origTitle: string;
  html: string; origMarkdown: string; published: boolean;
  // Inhalt wird nachgeladen; der Editor erscheint erst, wenn er gefüllt ist.
  loading: boolean; saving: boolean; error: string;
}>({
  visible: false, contentId: null, title: '', origTitle: '',
  html: '', origMarkdown: '', published: false, loading: false, saving: false, error: '',
});

function openMdCreate() {
  mdModal.value = {
    visible: true, contentId: null, title: '', origTitle: '',
    html: '', origMarkdown: '', published: false, loading: false, saving: false, error: '',
  };
}

function closeMdModal() {
  if (!mdModal.value.saving && !mdModal.value.loading) mdModal.value.visible = false;
}

async function saveMd() {
  const m = mdModal.value;
  m.error = '';
  const markdown = htmlToMarkdown(m.html);
  if (!m.title.trim()) { m.error = 'Bitte geben Sie einen Titel ein.'; return; }
  if (!markdown.trim()) { m.error = 'Bitte geben Sie einen Inhalt ein.'; return; }
  m.saving = true;
  try {
    if (!m.contentId) {
      await store.dispatch('instructionLibrary/CREATE_WITH_MARKDOWN', {
        title: m.title.trim(),
        text: markdown,
        confirmationItems: ['Inhalt gelesen und verstanden'],
        published: m.published,
      });
    } else {
      if (m.title.trim() !== m.origTitle || m.published !== publishedOf(m.contentId)) {
        await store.dispatch('instructionLibrary/UPDATE', {
          contentId: m.contentId,
          payload: { title: m.title.trim(), published: m.published },
        });
      }
      if (markdown !== m.origMarkdown) {
        await store.dispatch('instructionLibrary/ADD_VERSION_MARKDOWN', { contentId: m.contentId, text: markdown });
      }
    }
    m.visible = false;
  } catch (e: any) {
    m.error = e?.response?.data?.error || 'Beim Speichern ist ein Fehler aufgetreten.';
  } finally {
    m.saving = false;
  }
}

function publishedOf(contentId: string): boolean {
  const c = items.value.find((x) => x.contentId === contentId);
  return !!(c && c.published);
}

// ── Datei-Dokumente (PDF/Word) ────────────────────────────
const fileModal = ref<{
  visible: boolean; contentId: string | null; title: string; origTitle: string;
  file: File | null; published: boolean; saving: boolean; error: string;
}>({
  visible: false, contentId: null, title: '', origTitle: '',
  file: null, published: false, saving: false, error: '',
});

function openFileCreate() {
  fileModal.value = {
    visible: true, contentId: null, title: '', origTitle: '',
    file: null, published: false, saving: false, error: '',
  };
}

function closeFileModal() {
  if (!fileModal.value.saving) fileModal.value.visible = false;
}

function onFileSelected(e: Event) {
  const target = e.target as HTMLInputElement;
  const file = target.files && target.files[0];
  target.value = '';
  if (!file) return;
  fileModal.value.file = file;
  if (!fileModal.value.title.trim()) fileModal.value.title = titleFromFileName(file.name);
}

async function saveFile() {
  const m = fileModal.value;
  m.error = '';
  if (!m.title.trim()) { m.error = 'Bitte geben Sie einen Titel ein.'; return; }
  if (!m.contentId && !m.file) { m.error = 'Bitte wählen Sie eine Datei aus.'; return; }
  m.saving = true;
  try {
    if (!m.contentId) {
      await store.dispatch('instructionLibrary/CREATE_WITH_FILE', {
        title: m.title.trim(),
        file: m.file,
        confirmationItems: ['Inhalt gelesen und verstanden'],
        published: m.published,
      });
    } else {
      if (m.title.trim() !== m.origTitle || m.published !== publishedOf(m.contentId)) {
        await store.dispatch('instructionLibrary/UPDATE', {
          contentId: m.contentId,
          payload: { title: m.title.trim(), published: m.published },
        });
      }
      if (m.file) {
        await store.dispatch('instructionLibrary/ADD_VERSION_FILE', { contentId: m.contentId, file: m.file });
      }
    }
    m.visible = false;
  } catch (e: any) {
    m.error = e?.response?.data?.error || 'Beim Speichern ist ein Fehler aufgetreten.';
  } finally {
    m.saving = false;
  }
}

// ── Bearbeiten / Vorschau / Veröffentlichen / Löschen ─────
async function openEdit(c: InstructionContent) {
  if (String(c.fileType) === 'md') {
    mdModal.value = {
      visible: true, contentId: c.contentId, title: c.title, origTitle: c.title,
      html: '', origMarkdown: '', published: c.published === true, loading: true, saving: false, error: '',
    };
    try {
      const text = c.currentVersion > 0
        ? await store.dispatch('instructionLibrary/GET_DOC_TEXT', { contentId: c.contentId })
        : '';
      mdModal.value.origMarkdown = text;
      mdModal.value.html = renderMarkdownRaw(text);
    } catch (e) {
      mdModal.value.error = 'Der Dokumentinhalt konnte nicht geladen werden.';
    } finally {
      mdModal.value.loading = false;
    }
  } else {
    fileModal.value = {
      visible: true, contentId: c.contentId, title: c.title, origTitle: c.title,
      file: null, published: c.published === true, saving: false, error: '',
    };
  }
}

async function openPreview(c: InstructionContent) {
  if (String(c.fileType) === 'md') {
    try {
      const text = await store.dispatch('instructionLibrary/GET_DOC_TEXT', { contentId: c.contentId });
      openMarkdownPreview(c.title, text, {});
    } catch (e) {
      window.alert('Dokument konnte nicht geöffnet werden.');
    }
    return;
  }
  const w = window.open('', '_blank');
  try {
    const res = await store.dispatch('instructionLibrary/GET_DOC_URL', { contentId: c.contentId });
    if (w && res && res.url) w.location.href = res.url;
    else if (w) w.close();
  } catch (e) {
    if (w) w.close();
    window.alert('Dokument konnte nicht geöffnet werden.');
  }
}

async function togglePublish(c: InstructionContent) {
  try {
    await store.dispatch('instructionLibrary/UPDATE', {
      contentId: c.contentId,
      payload: { published: !c.published },
    });
  } catch (e) {
    window.alert('Status konnte nicht geändert werden.');
  }
}

const deleteTarget = ref<InstructionContent | null>(null);
const deleting = ref(false);
const deleteError = ref('');

function doDelete(c: InstructionContent) {
  deleteError.value = '';
  deleteTarget.value = c;
}

async function confirmDelete() {
  if (!deleteTarget.value) return;
  deleting.value = true;
  deleteError.value = '';
  try {
    await store.dispatch('instructionLibrary/DELETE', deleteTarget.value.contentId);
    deleteTarget.value = null;
  } catch (e) {
    deleteError.value = 'Löschen fehlgeschlagen. Bitte versuchen Sie es erneut.';
  } finally {
    deleting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("nav", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: "/superadmin/organisations",
        class: "sa-subnav-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Organisationen")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/superadmin/courses",
        class: "sa-subnav-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Kurse")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/superadmin/instruction-library",
        class: "sa-subnav-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Dokumente")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", { class: "sa-header" }, [
      _hoisted_4,
      _createElementVNode("div", { class: "sa-header-actions" }, [
        _createElementVNode("button", {
          class: "btn btn-secondary",
          onClick: openFileCreate
        }, "Datei hochladen"),
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: openMdCreate
        }, "Dokument schreiben")
      ])
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Wird geladen …"))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(error.value), 1))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
              type: "text",
              class: "il-input il-search",
              placeholder: "Dokumente durchsuchen …",
              "aria-label": "Dokumente durchsuchen"
            }, null, 512), [
              [_vModelText, query.value]
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("tbody", null, [
                  (!_unref(filteredItems).length)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                        _createElementVNode("td", _hoisted_11, _toDisplayString(query.value ? 'Keine passenden Dokumente gefunden.' : 'Noch keine Dokumente angelegt.'), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredItems), (c) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: c.contentId
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(c.title), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(typeLabel(c)), 1),
                      _createElementVNode("td", null, _toDisplayString(c.currentVersion > 0 ? 'v' + c.currentVersion : '—'), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['status-badge', c.published ? 'status-published' : 'status-draft'])
                        }, _toDisplayString(c.published ? 'Veröffentlicht' : 'Entwurf'), 3)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(DotMenu, null, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "dot-menu-item",
                                onClick: ($event: any) => (openEdit(c))
                              }, [
                                _hoisted_15,
                                _createTextVNode(" Bearbeiten ")
                              ], 8, _hoisted_14),
                              _createElementVNode("button", {
                                class: "dot-menu-item",
                                disabled: c.currentVersion < 1,
                                onClick: ($event: any) => (openPreview(c))
                              }, [
                                _hoisted_17,
                                _createTextVNode(" Vorschau ")
                              ], 8, _hoisted_16),
                              _createElementVNode("button", {
                                class: "dot-menu-item",
                                onClick: ($event: any) => (togglePublish(c))
                              }, [
                                _hoisted_19,
                                _createTextVNode(" " + _toDisplayString(c.published ? 'Zurückziehen' : 'Veröffentlichen'), 1)
                              ], 8, _hoisted_18),
                              _createElementVNode("button", {
                                class: "dot-menu-item danger",
                                onClick: ($event: any) => (doDelete(c))
                              }, [
                                _hoisted_21,
                                _createTextVNode(" Löschen ")
                              ], 8, _hoisted_20)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ], 64)),
    (mdModal.value.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "sa-modal-backdrop",
          onClick: _withModifiers(closeMdModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("h3", null, _toDisplayString(mdModal.value.contentId ? 'Dokument bearbeiten' : 'Neues Dokument'), 1),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _withDirectives(_createElementVNode("input", {
                id: "il-md-title",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((mdModal.value.title) = $event)),
                class: "il-input",
                type: "text",
                placeholder: "z. B. QMH – 1 – Arbeitsschutz"
              }, null, 512), [
                [_vModelText, mdModal.value.title]
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              (mdModal.value.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_31))
                : (_openBlock(), _createBlock(RichTextEditor, {
                    key: 1,
                    modelValue: mdModal.value.html,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((mdModal.value.html) = $event)),
                    placeholders: "",
                    "aria-label": "Dokumentinhalt"
                  }, null, 8, ["modelValue"])),
              _hoisted_32
            ]),
            _createElementVNode("label", _hoisted_33, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((mdModal.value.published) = $event))
              }, null, 512), [
                [_vModelCheckbox, mdModal.value.published]
              ]),
              _hoisted_34
            ]),
            (mdModal.value.error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(mdModal.value.error), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                disabled: mdModal.value.saving || mdModal.value.loading,
                onClick: closeMdModal
              }, "Abbrechen", 8, _hoisted_37),
              _createElementVNode("button", {
                class: "btn btn-primary",
                disabled: mdModal.value.saving || mdModal.value.loading,
                onClick: saveMd
              }, _toDisplayString(mdModal.value.saving ? 'Wird gespeichert …' : 'Speichern'), 9, _hoisted_38)
            ])
          ])
        ], 8, _hoisted_22))
      : _createCommentVNode("", true),
    (fileModal.value.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "sa-modal-backdrop",
          onClick: _withModifiers(closeFileModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("h3", null, _toDisplayString(fileModal.value.contentId ? 'Dokument bearbeiten' : 'Datei hochladen'), 1),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _withDirectives(_createElementVNode("input", {
                id: "il-file-title",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((fileModal.value.title) = $event)),
                class: "il-input",
                type: "text",
                placeholder: "z. B. Gewalt in der Pflege"
              }, null, 512), [
                [_vModelText, fileModal.value.title]
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("label", _hoisted_44, [
                _createTextVNode(_toDisplayString(fileModal.value.contentId ? 'Neue Version (optional)' : 'Datei (PDF oder Word)'), 1),
                (!fileModal.value.contentId)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_45, " *"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("label", {
                class: _normalizeClass(["il-filedrop", { uploading: fileModal.value.saving }])
              }, [
                _createElementVNode("input", {
                  type: "file",
                  accept: ACCEPT,
                  disabled: fileModal.value.saving,
                  onChange: onFileSelected
                }, null, 40, _hoisted_46),
                _createElementVNode("span", null, _toDisplayString(fileModal.value.file ? fileModal.value.file.name : '+ Datei auswählen'), 1)
              ], 2),
              (fileModal.value.contentId)
                ? (_openBlock(), _createElementBlock("p", _hoisted_47, " Ohne neue Datei wird nur der Titel gespeichert. Eine neue Datei wird als neue Version abgelegt. "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("label", _hoisted_48, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((fileModal.value.published) = $event))
              }, null, 512), [
                [_vModelCheckbox, fileModal.value.published]
              ]),
              _hoisted_49
            ]),
            (fileModal.value.error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_50, _toDisplayString(fileModal.value.error), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                disabled: fileModal.value.saving,
                onClick: closeFileModal
              }, "Abbrechen", 8, _hoisted_52),
              _createElementVNode("button", {
                class: "btn btn-primary",
                disabled: fileModal.value.saving,
                onClick: saveFile
              }, _toDisplayString(fileModal.value.saving ? 'Wird gespeichert …' : 'Speichern'), 9, _hoisted_53)
            ])
          ])
        ], 8, _hoisted_39))
      : _createCommentVNode("", true),
    (deleteTarget.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "sa-modal-backdrop",
          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (deleteTarget.value = null), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _createElementVNode("p", null, " Soll das Dokument „" + _toDisplayString(deleteTarget.value.title) + "\" wirklich gelöscht werden? Es verschwindet damit auch aus Unterweisungen von Einrichtungen, die es verwenden. Das lässt sich nicht rückgängig machen. ", 1),
            (deleteError.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_56, _toDisplayString(deleteError.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                disabled: deleting.value,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (deleteTarget.value = null))
              }, "Abbrechen", 8, _hoisted_58),
              _createElementVNode("button", {
                class: "btn btn-danger-solid",
                disabled: deleting.value,
                onClick: confirmDelete
              }, _toDisplayString(deleting.value ? 'Wird gelöscht …' : 'Löschen'), 9, _hoisted_59)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})